<template>
  <div>
    <ValidationProvider v-slot='{ errors, passed, failed }' :rules="{ 'required': true}" slim>
      <div :class="[failed && 'lib__field--error', passed && 'lib__field--valid']" class='lib__field'>
        <div class='lib__tiles lib__tiles--inline'>
          <TileRadio
            v-model='value.hasRelay'
            :item='true'
            :label="$t('common.yes')"
            group='relay'>
            <template v-slot:picture>
              <i class='fas fa-check'></i>
            </template>
          </TileRadio>
          <TileRadio
            v-model='value.hasRelay'
            :item='false'
            :label="$t('common.no')"
            group='relay'>
            <template v-slot:picture>
              <i class='fas fa-times'></i>
            </template>
          </TileRadio>
        </div>
        <error-message :error='errors[0]'></error-message>
      </div>
    </ValidationProvider>

    <template v-if='value.hasRelay === true'>
      <label class='lib__field__label lib__no-padding'>
        {{ $t('prosumerDeclaration.relay.decouplingRelay1') }}
        <span class='lib__tooltips' @click='decouplingRelayModalOpen = true'>
              <span>
                <i class='fas fa-info-circle lib__clickable-tooltips'></i>
              </span>
        </span>
      </label>
      <div class='row'>
        <div class='col-xs-12 col-md-6'>
          <text-box v-model='value.firstDecouplingRelay.brand' :placeholder="$t('prosumerDeclaration.relay.brand')" />
        </div>
        <div class='col-xs-12 col-md-6'>
          <text-box v-model='value.firstDecouplingRelay.type' :placeholder="$t('prosumerDeclaration.relay.type')" />
        </div>
      </div>

      <label class='lib__field__label lib__no-padding'>
        {{ $t('prosumerDeclaration.relay.decouplingRelay2') }}
        <span class='lib__tooltips' @click='decouplingRelayModalOpen = true'>
              <span>
                <i class='fas fa-info-circle lib__clickable-tooltips'></i>
              </span>
        </span>
      </label>
      <div class='row'>
        <div class='col-xs-12 col-md-6'>
          <text-box v-model='value.secondDecouplingRelay.brand' :placeholder="$t('prosumerDeclaration.relay.brand')" />
        </div>
        <div class='col-xs-12 col-md-6'>
          <text-box v-model='value.secondDecouplingRelay.type' :placeholder="$t('prosumerDeclaration.relay.type')" />
        </div>
      </div>

      <label class='lib__field__label lib__no-padding'>
        {{ $t('prosumerDeclaration.relay.nonReturnRelay') }}
        <span class='lib__tooltips' @click='nonReturnRelayModalOpen = true'>
              <span>
                <i class='fas fa-info-circle lib__clickable-tooltips'></i>
              </span>
        </span>
      </label>
      <div class='row'>
        <div class='col-xs-12 col-md-4'>
          <text-box v-model='value.nonReturnRelay.brand' :placeholder="$t('prosumerDeclaration.relay.brand')" />
        </div>
        <div class='col-xs-12 col-md-4'>
          <text-box v-model='value.nonReturnRelay.type' :placeholder="$t('prosumerDeclaration.relay.type')" />
        </div>
        <div class='col-xs-12 col-md-4'>
          <number-box v-model='value.nonReturnRelay.power'
                      :placeholder="$t('prosumerDeclaration.relay.kvaSettings')" />
        </div>
      </div>
    </template>

    <ModalDialog :closeable="$t('common.close')" :open.sync='decouplingRelayModalOpen'>
      <h3>{{ $t('prosumerDeclaration.relay.modal.decouplingRelay.title') }}</h3>
      <p v-html="$t('prosumerDeclaration.relay.modal.decouplingRelay.text')" />
    </ModalDialog>

    <ModalDialog :closeable="$t('common.close')" :open.sync='nonReturnRelayModalOpen'>
      <h3>{{ $t('prosumerDeclaration.relay.modal.nonReturnRelay.title') }}</h3>
      <p v-html="$t('prosumerDeclaration.relay.modal.nonReturnRelay.text')" />
    </ModalDialog>
  </div>
</template>

<script lang='ts'>
import Component from 'vue-class-component'
import { Prop, Vue, Watch } from 'vue-property-decorator'
import { RelayInformation } from '@/models/prosumer-declaration/prosumer-declaration'

@Component({
  name: 'relay-information-component'
})
export default class RelayInformationComponent extends Vue {
  @Prop({ type: Object, required: true }) public readonly value!: RelayInformation

  public decouplingRelayModalOpen: boolean = false
  public nonReturnRelayModalOpen: boolean = false

 @Watch('value.hasRelay', { deep: true })
  public onHasRelayChanged(newVal: boolean) {
      this.value.firstDecouplingRelay = { brand: null, type: null }
      this.value.secondDecouplingRelay = { brand: null, type: null }
      this.value.nonReturnRelay = { brand: null, type: null, power: null }

  }

}
</script>
